import React from "react";
import CountryLayout from "@/components/CountryLayout";

export default function CountrySwitzerland() {
  return <CountryLayout countryKey="switzerland" countryCode="ch" sourcePage="/countries/switzerland" />;
}
